module.exports = __webpack_public_path__ + "static/media/cooking-oils.7e3eb56a.webp";